import { lead, bio, highlights, skills, outside } from '../../data/about'
import './index.scss'

const skillGroups = Object.entries(skills).map(([name, items]) => ({ name, items }))

const About = () => (
  <div className='ab-root'>
  <div className='ab-inner'>

    {/* ── Intro + portrait ──────────────────────────────────── */}
    <div className='ab-intro'>
      <div className='ab-intro__copy'>
        <div className='ab-eyebrow'>( ABOUT )</div>
        <h1 className='ab-lead'>{lead}</h1>
        <div className='ab-bio'>
          {bio.map((para, i) => (
            <p key={i} className='ab-bio__para'>{para}</p>
          ))}
        </div>
      </div>
      {/* <div className='ab-portrait'>
        <div className='ab-portrait__placeholder'>Portrait</div>
      </div> */}
    </div>

    {/* ── Highlights ────────────────────────────────────────── */}
    <div className='ab-highlights'>
      {highlights.map(({ value, label }) => (
        <div key={label} className='ab-stat'>
          <div className='ab-stat__value'>{value}</div>
          <div className='ab-stat__label'>{label}</div>
        </div>
      ))}
    </div>

    {/* ── Skills ────────────────────────────────────────────── */}
    <div className='ab-skills'>
      <div className='ab-eyebrow'>( STACK )</div>
      <h2 className='ab-skills__heading'>Tools I build with</h2>
      <div className='ab-skills__list'>
        {skillGroups.map(({ name, items }) => (
          <div key={name} className='ab-skill-row'>
            <div className='ab-skill-row__name'>{name}</div>
            <div className='ab-skill-row__pills'>
              {items.map((s) => (
                <span key={s} className='ab-pill'>{s}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* ── Outside of work ───────────────────────────────────── */}
    <div className='ab-outside'>
      <div className='ab-eyebrow'>( OFF THE CLOCK )</div>
      <p className='ab-outside__text'>{outside}</p>
    </div>

  </div>
  </div>
)

export default About
